export const checkPolicyUtil = (policies: string[] = [], policy: string) => {
  return policies.includes(policy)
}
